import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Card, Row, Col } from 'antd';
import ETLMappingEditor from './ETLMappingEditor';

const { Option } = Select;

function SchemaForm({ handleSubmitSchema, editingSchema = null }) {
    const [form] = Form.useForm();
    const [fieldMapping, setFieldMapping] = useState([]);

    useEffect(() => {
        if (editingSchema) {
            const { fieldMapping = [], ...rest } = editingSchema;
            form.setFieldsValue(rest);
            setFieldMapping(fieldMapping);
        }
    }, [editingSchema]);

    const onFinish = (values) => {
        const schemaData = {
            ...values,
            fieldMapping,
        };
        if (editingSchema && editingSchema.id) {
            schemaData.id = editingSchema.id;
        }

        handleSubmitSchema(schemaData);
        form.resetFields();
        setFieldMapping([]);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{ format: 'json' }}
        >
            <Card title="Thông tin Schema" style={{ marginBottom: 16 }}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="name" label="Tên Schema" rules={[{ required: true }]}>
                            <Input placeholder="CustomerSchema" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="format" label="Định dạng">
                            <Select>
                                <Option value="json">JSON</Option>
                                <Option value="xml">XML</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="description" label="Mô tả">
                            <Input.TextArea rows={3} />
                        </Form.Item>
                    </Col>
                </Row>
            </Card>

            <Row gutter={16}>
                <Col span={16}>
                    <ETLMappingEditor
                        initialFieldMapping={fieldMapping}
                        onMappingChange={setFieldMapping}
                    />
                </Col>
            </Row>

            <div style={{ marginTop: 24, textAlign: 'right' }}>
                <Button type="primary" htmlType="submit">
                    Lưu Schema
                </Button>
            </div>
        </Form>
    );
}

export default SchemaForm;
